<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group text-left">
          <router-link :to="{path: '/crAccount'}">
            <div class="btn btn-default btn-table-title">新增帳號</div>
          </router-link>
        </div>
        <!--<div class="form-group">-->
          <!--<select class="form-control h-38" v-model="selectRoleType">-->
            <!--<option value="all">全部</option>-->
            <!--<option value="admin">系統</option>-->
            <!--<option value="brand">品牌</option>-->
            <!--<option value="store">店家</option>-->
          <!--</select>-->
        <!--</div>-->
      </div>
      <div v-if="selectRoleType!='pos'" class="col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38" v-model="searchKey">
            <option value="name">名稱</option>
            <option value="account">帳號</option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div class="input-group">
            <input class="form-control" type="text" v-model="searchValue" />
            <span class="input-group-addon c-pointer" @click="getAccountList(1)"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <ul class="nav nav-tabs" style="margin-bottom: 10px;">
          <li role="presentation":class="{active: isType('admin')}">
            <a @click.prevent="selectRoleType = 'admin'">系統
            </a>
          </li>
          <li role="presentation" :class="{active: isType('brand')}">
            <a @click.prevent="selectRoleType = 'brand'">品牌
            </a>
          </li>
          <li role="presentation" :class="{active: isType('store')}">
            <a @click.prevent="selectRoleType = 'store'">店家
            </a>
          </li>
          <li role="presentation" :class="{active: isType('pos')}">
            <a @click.prevent="selectRoleType = 'pos'">POS
            </a>
          </li>
        </ul>
      </div>
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable" v-if="managerList.length">
          <thead>
          <tr role="row">
            <th>#</th>
            <th>名稱</th>
            <th>帳號</th>
            <th>ID</th>
            <!--<th>角色</th>-->
            <th>權限</th>
            <!--<th>建立帳號者</th>-->
            <!--<th>最後登入時間</th>-->
            <!--<th>更新時間</th>-->
            <th>建立時間</th>
            <!--<th>手機</th>-->
            <!--<th>信箱</th>-->
            <!--<th>生日</th>-->
            <!--<th>性別</th>-->
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr class="even" role="row" v-for="(manager, index) in managerList" v-if="showSelect(manager.role_type)">
            <td class="sorting_1">
              <span>{{index + 1}}</span>
            </td>
            <td>{{manager.name}}</td>
            <td>{{manager.account}}</td>
            <td>{{manager.manager_id}}</td>
            <!--<td>{{roleName(manager.role_type)}}</td>-->
            <td>
              <span v-if="!manager.is_suspend" class="label label-success">正常</span>
              <span v-if="manager.is_suspend"  class="label label-danger">停權</span>
            </td>
            <!--<td><span v-if="manager.create_manager_id">{{manager.create_manager_id}}</span></td>-->
            <!--<td>{{manager.last_login_time}}</td>-->
            <!--<td>{{manager.edit_time}}</td>-->
            <td>{{manager.create_time}}</td>
            <!--<td>{{manager.phone}}</td>-->
            <!--<td>{{manager.email}}</td>-->
            <!--<td>{{manager.birth}}</td>-->
            <!--
            <td>
              <span v-if="manager.sex == 1" class="text-blue"><i class="fa fa-male" aria-hidden="true"></i></span>
              <span v-if="manager.sex == 2"  class="text-red"><i class="fa fa-female" aria-hidden="true"></i></span>
            </td>
            -->
            <td>
              <button class="btn btn-danger" v-if="manager.account != 'admin' && manager.account != 'matcher_admin'"
                      data-toggle="modal" data-target="#delModal" @click="getCurrent(manager.role_type, manager.manager_id, manager.account, manager.name)"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </td>
            <td>
              <router-link :to="{path: '/upAccount/' + manager.role_type + '/' + manager.manager_id}">
                <button class="btn btn-default"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage"
      >
      </paginate>
    </div>
    <m-modal :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import matcherModal from '../../../elements/Modal.vue'
import $ from 'jquery'
export default{
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      count: 10,
      managerList: [],
      show: {
        brand: false,
        menu: false,
        schedule: false
      },
      type: 'admin',
      selectRoleType: 'admin',
      total: 0,
      maxTotal: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      delOption: {
        id: 'delModal',
        title: '刪除帳號',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delManager'
          }
        ]
      },
      current: {
        role_type: '',
        manager_id: '',
        account: '',
        account_name: ''
      },
      searchKey: 'name',
      searchValue: ''
    }
  },
  methods: {
    trigger (event) {
      if (event === 'delManager') {
        this.delManager()
      }
    },
    delManager () {
      var self = this
      var url = '/manager/' + self.current.role_type + '/' + self.current.manager_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getAccountList(1)
        }
      })
    },
    showSelect (type) {
      if (this.selectRoleType === 'all') return true
      else {
        if (this.selectRoleType === type) return true
        else return false
      }
    },
    getAccountList (index) {
      this.tableIndex = index
      this.managerList = []
      var self = this
      const data = {
        page: this.tableIndex,
        count: this.count
      }
      var url = '/manager/' + self.selectRoleType + '/list?page=' + data.page + '&size=' + data.count
      if (this.searchValue) {
        url += '&' + this.searchKey + '=' + this.searchValue
      }
      this.getDataH('get', url, data, function (response) {
        if (response.data.status === 200) {
          for (let j = 0; j < response.data.manager_list.length; j++) {
            const manager = response.data.manager_list[j]
            manager['role_type'] = self.selectRoleType
            self.managerList.push(manager)
          }
          if (self.managerList.length === 0) $('.dataTables_empty').css('display', 'show')
          self.maxTotal = response.data.total
          self.total = response.data.total
        }
      })
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    isType (type) {
      if (this.selectRoleType === type) return true
      else return false
    },
    roleName (type) {
      if (type === 'admin') {
        return '系統'
      } else if (type === 'brand') {
        return '品牌'
      } else if (type === 'store') {
        return '店家'
      }
    },
    getCurrent (roleType, managerId, account, accountName) {
      this.current.role_type = roleType
      this.current.manager_id = managerId
      this.current.account = account
      this.current.account_name = accountName
      this.delOption.body = '確定刪除 ' + accountName + ' ?<br>刪除此管理者，將無法再用此帳號登入！'
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getAccountList(index)
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    this.fixedH()
    if (this.$route.name === 'brandTable') this.show.brand = true
    else if (this.$route.name === 'menuTable') this.show.menu = true
    else if (this.$route.name === 'scheduleTable') this.show.schedule = true
    this.getAccountList(1)
  },
  watch: {
    selectRoleType () {
      this.searchValue = '' // 切換tab時清空搜尋條件
      this.getAccountList(1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccountTableTemp.vue?72d58519